import fetchServer from "../helpers/api/fetchServer";

export const createInterest = async ({
  name,
  adPlatformId,
  languageId,
  interestGroupId,
  interestExternalId,
  category,
  topic,
  pathLabel,
  reachLowerBound,
  reachUpperBound,
}) => {
  const method = "POST";
  const urlAPI = "/api/interests";
  const body = {
    name,
    adPlatform: adPlatformId,
    language: languageId,
    interestGroup: interestGroupId || null,
    interestExternalId,
    category,
    topic,
    pathLabel,
    ...(reachLowerBound ? { reachLowerBound } : {}),
    ...(reachUpperBound ? { reachUpperBound } : {}),
  };
  return await fetchServer({ method, urlAPI, body });
};

export const getInterests = async () => {
  const method = "GET";
  const urlAPI = "/api/interests";
  return await fetchServer({ method, urlAPI });
};

export const searchInterests = async ({
  adPlatformId,
  adAccountId,
  languageId,
  searchTerm,
}) => {
  const method = "GET";
  const urlAPI = `/api/interests/search?adPlatform=${adPlatformId}&adAccount=${adAccountId}&language=${languageId}&searchTerm=${encodeURIComponent(
    searchTerm
  )}`;
  return await fetchServer({ method, urlAPI });
};

export const getInterestsByAdPlatform = async (adPlatformId) => {
  const method = "GET";
  const urlAPI = `/api/interests?adPlatform=${adPlatformId}`;
  return await fetchServer({ method, urlAPI });
};

export const getInterest = async (id) => {
  const method = "GET";
  const urlAPI = `/api/interests/${id}`;
  return await fetchServer({ method, urlAPI });
};

export const updateInterest = async ({ id, interestGroupId }) => {
  const method = "PATCH";
  const urlAPI = `/api/interests/${id}`;
  const body = {
    interestGroup: interestGroupId  || null,
  };
  return await fetchServer({ method, urlAPI, body });
};

export const deleteInterest = async (id) => {
  const method = "DELETE";
  const urlAPI = `/api/interests/${id}`;
  return await fetchServer({ method, urlAPI });
};

export const restoreInterest = async (id) => {
  const method = "POST";
  const urlAPI = `/api/interests/${id}/restore`;
  return await fetchServer({ method, urlAPI });
};

export const deleteInterests = async (ids) => {
  const method = "POST";
  const urlAPI = "/api/interests/bulk-delete";
  const body = {ids};
  return await fetchServer({ method, urlAPI, body });
};

export const restoreInterests = async (ids) => {
  const method = "POST";
  const urlAPI = "/api/interests/bulk-restore";
  const body = {ids};
  return await fetchServer({ method, urlAPI, body });
};
